/**
 * Image Popup Handler
 * 
 * Simple popup system for viewing enlarged images.
 * Click on preview image to open popup, close with ESC key, close button, or click outside.
 */

function inicializarPopups() {
  const imagensPreview = document.querySelectorAll('.custom_image_preview[data-popup-id]');

  imagensPreview.forEach((imagemPreview) => {
    if (imagemPreview.dataset.inicializado === 'true') return;
    imagemPreview.dataset.inicializado = 'true';

    const popupId = imagemPreview.getAttribute('data-popup-id');
    const popup = document.getElementById(popupId);
    if (!popup) return;

    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }

    const imagemPopup = popup.querySelector('.custom_popup_content');
    const botaoFechar = popup.querySelector('.custom_close');
    const loading = popup.querySelector('.custom_loading');

    if (!imagemPopup || !botaoFechar || !loading) return;

    imagemPreview.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      popup.classList.add('show');
      popup.classList.remove('hide');
      popup.style.display = 'block';
      document.body.classList.add('body-popup-open');

      loading.style.display = 'block';
      imagemPopup.src = imagemPreview.src;

      imagemPopup.onload = () => {
        loading.style.display = 'none';
        imagemPopup.classList.add('loaded');
      };

      imagemPopup.onerror = () => {
        loading.style.display = 'none';
      };
    });

    function fechar() {
      popup.classList.add('hide');
      popup.classList.remove('show');
      imagemPopup.classList.remove('loaded');
      document.body.classList.remove('body-popup-open');

      setTimeout(() => {
        popup.style.display = 'none';
        imagemPopup.src = '';
      }, 400);
    }

    botaoFechar.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      fechar();
    });

    popup.addEventListener('click', (e) => {
      if (e.target === popup) fechar();
    });

    imagemPopup.addEventListener('click', (e) => e.stopPropagation());
    loading.addEventListener('click', (e) => e.stopPropagation());
  });
}

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const popupAberto = document.querySelector('.custom_popup.show');
    if (popupAberto) {
      const imagemPopup = popupAberto.querySelector('.custom_popup_content');
      popupAberto.classList.add('hide');
      popupAberto.classList.remove('show');
      if (imagemPopup) imagemPopup.classList.remove('loaded');
      document.body.classList.remove('body-popup-open');
      setTimeout(() => {
        popupAberto.style.display = 'none';
        if (imagemPopup) imagemPopup.src = '';
      }, 400);
    }
  }
});

document.addEventListener('DOMContentLoaded', inicializarPopups);
